import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TimerComponent,
      multi: true
    }
  ]
})
export class TimerComponent implements OnInit, OnDestroy, ControlValueAccessor {
  timeLeft: number = environment.otp.resendCooldownSeconds;
  interval: any;
  isNotVisible: boolean = false;
  model: string;
  onChange!: (value: any) =>  void;
  
  constructor(public cdr: ChangeDetectorRef) { 
    this.model = '';
  }

  writeValue(obj: any): void {
    this.isNotVisible = obj;
    if(!this.isNotVisible){
      this.stopTimer();
      this.startTimer();
    }else{
      this.stopTimer();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }

  ngOnInit(): void {
    this.startTimer();
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  stopTimer(): void {
    clearInterval(this.interval);
  }

  startTimer(): void {
    this.timeLeft = environment.otp.resendCooldownSeconds;
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
        this.cdr.detectChanges();
      } else {
        this.onChange(true);
        this.isNotVisible = true;
        this.stopTimer();
        this.cdr.markForCheck();
      }
    }, 1000);
  }
}
